/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import configENV from '../../config';

const { PERSIST_KEY } = configENV;

// TODO: Need to replace phone number with the config variable
const RemoveCreditCard = (props) => {
    const {
        isReadyState,
        walletId,
        wallet,
        handleCloseModal,
        handleRemoveCreditCard,
    } = props;

    const selectedWallet = wallet.filter((w) => w.walletId === walletId);
    if (selectedWallet.length === 0) return null;
    const { lastFourDigits } = selectedWallet[0];
    return (
        <>
            <p>
                The credit card ending {lastFourDigits} will be permanently
                removed from your wallet.
            </p>

            <div className="margin-top-2x align-center">
                <Button
                    onClick={() => handleRemoveCreditCard(walletId)}
                    variant="contained"
                    color="primary"
                    className="remove-recipient-btn buttonHD margin-bottom-2x"
                >
                    {isReadyState ? 'Delete Credit Card' : 'Deleting...'}
                </Button>
                <Button
                    onClick={() => handleCloseModal()}
                    variant="contained"
                    className="do-not-remove-btn buttonHDSecondary"
                >
                    Don&apos;t delete
                </Button>
            </div>
        </>
    );
};

RemoveCreditCard.propTypes = {
    isReadyState: PropTypes.bool.isRequired,
    walletId: PropTypes.string.isRequired,
    wallet: PropTypes.array.isRequired,
    handleCloseModal: PropTypes.func.isRequired,
    handleRemoveCreditCard: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        walletId: newState.walletId,
        wallet: newState.wallet,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
    handleRemoveCreditCard: (walletId) => dispatch(EventDispatcher.handleRemoveCreditCard(walletId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RemoveCreditCard);
